export default "__VITE_ASSET__b953641a__"